import { env } from 'env.mjs';

type DeploymentTarget = typeof env.NEXT_PUBLIC_DEPLOYMENT_TARGET;

export const checkDeploymentTarget = (deploymentTarget: DeploymentTarget) =>
  env.NEXT_PUBLIC_DEPLOYMENT_TARGET === deploymentTarget;

export const isMAHD = () => checkDeploymentTarget('OCI');
